import React from 'react';
import classnames from 'classnames/bind';
import { Icon } from '../Icon';
import styles from './ProductSlideContentV9.css';

const cx = classnames.bind(styles);

const COMPARISON_ROWS = [
    {
        withBoundly: 'Saved in one place',
        whenWaiting: 'They stay only in my head'
    },
    {
        withBoundly: 'Photo stories preserved',
        whenWaiting: 'Names and details keep fading'
    },
    {
        withBoundly: 'Words become chapters',
        whenWaiting: 'The task keeps feeling too big'
    },
    {
        withBoundly: 'I begin while I can still tell it',
        whenWaiting: 'Someday keeps moving'
    }
];

function ProductSlideContentV9() {
    return (
        <div className={styles.form}>
            <div className={styles.headingSection}>
                <h2 className={styles.heading}>Waiting has a cost</h2>
                <p className={styles.description}>The stories are already there. What changes is whether they are given a place to remain.</p>
            </div>
            <div className={styles.table}>
                <div className={styles.tableHeader}>
                    <p className={styles.columnLabel}>With Boundly</p>
                    <p className={styles.columnLabel}>If I keep waiting</p>
                </div>
                {COMPARISON_ROWS.map(row => (
                    <div className={styles.row} key={row.withBoundly}>
                        <div className={styles.cell}>
                            <Icon name='check' className={cx('icon', 'iconCheck')} />
                            <p className={styles.cellText}>{row.withBoundly}</p>
                        </div>
                        <div className={styles.cell}>
                            <Icon name='close' className={cx('icon', 'iconCross')} />
                            <p className={cx('cellText', 'cellTextMuted')}>{row.whenWaiting}</p>
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
}

export {
    ProductSlideContentV9
};
